/* eslint react/no-multi-comp: 0 */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import {get} from 'lodash';
import classNames from 'classnames';
import ContentCaption from './content_caption';
import Lazy from '../common/lazy';
import MediaQuery from '../common/media_query';
import ResponsiveImg from '../common/responsive_img';
import { scrollContainerToChildIfNecessary } from '../../utils/dom';

const Aux = props => props.children;

export default class GetEmbedGallerySection extends PureComponent {
  state = { activeImage: 0 };

  handleImageClicked = (index) => {
    if (index !== this.state.activeImage) {
      this.setState({ activeImage: index });
    }
  }

  handlePrevClicked = () => {
    const { images } = this.props.content;
    this.setState({
      activeImage: this.state.activeImage === 0
        ? images.length - 1
        : this.state.activeImage - 1
    }, this.scrollToActiveImage);
  }

  handleNextClicked = () => {
    const { images } = this.props.content;
    this.setState({
      activeImage: this.state.activeImage === images.length - 1
        ? 0
        : this.state.activeImage + 1
    }, this.scrollToActiveImage);
  }

  scrollToActiveImage = () => {
    this.activeImageComponent.scrollContainerToMe(this.galleryContainerNode);
  }

  render() {
    return (
      <div className="section-gallery-container">
        <div className="section-gallery">
          <div className="prev" onClick={this.handlePrevClicked} />
          <div
            className="gallery-image-container"
            ref={(element => { this.galleryContainerNode = element; })}
          >
            {
              this.props.content.images.map((image, index) =>
                <GalleryImage
                  key={index}
                  isActive={this.state.activeImage === index}
                  onClick={this.handleImageClicked}
                  index={index}
                  ref={(element) => {
                    if (this.state.activeImage === index) {
                      this.activeImageComponent = element;
                    }
                  }}
                  {...image}
                />
              )
            }
          </div>
          <div className="next" onClick={this.handleNextClicked} />
        </div>
        {
          this.props.content.credit
          && <ContentCaption credit={this.props.content.credit} />
        }
      </div>
    );
  }
}

GetEmbedGallerySection.propTypes = {
  content: PropTypes.shape({
    images: PropTypes.arrayOf(PropTypes.object).isRequired,
    credit: PropTypes.string
  })
};

const NOT_MOBILE_IMAGE_HEIGHT = 500;
const MOBILE_IMAGE_HEIGHT = 300;

export class GalleryImage extends PureComponent {
  state = { isLoaded: false };

  handleClick = () => {
    this.props.onClick(this.props.index);
  }

  // Called by the parent component after clicking one of the arrows
  scrollContainerToMe = (galleryContainerNode) => {
    scrollContainerToChildIfNecessary(
      galleryContainerNode, this.divNode, window
    );
  }

  responsiveImg = () => {
    const img = get(this.props, 'portrait') || get(this.props, 'landscape');

    const {
      original_width_px, original_height_px
    } = img.dimensions;

    const imgProps = {
      className: this.state.isLoaded ? null : 'loading',
      src: img.src,
      onLoad: this.handleImgLoad,
      original_width_px,
      original_height_px,
      location: this.context.location
    };

    /*
     * The gallery is 500px tall on desktop and tablet, and 300px tall on mobile
     * (enforced by CSS). Given that constraint, we can calculate the correct
     * width and height to pass into `ResponsiveImg`.
     *
     * Specifically, we can use the ratio derived from `original_width_px`
     * and `original_height_px` to figure out the appropriate width.
     */

    return (
      <Aux>
        <MediaQuery breakpoint="notMobile">
          <ResponsiveImg
            {...imgProps}
            width={original_width_px / original_height_px * NOT_MOBILE_IMAGE_HEIGHT}
            height={NOT_MOBILE_IMAGE_HEIGHT}
          />
        </MediaQuery>
        <MediaQuery breakpoint="mobile">
          <ResponsiveImg
            {...imgProps}
            width={original_width_px / original_height_px * MOBILE_IMAGE_HEIGHT}
            height={MOBILE_IMAGE_HEIGHT}
          />
        </MediaQuery>
      </Aux>
    );
  }

  handleImgLoad = () =>
    this.setState({ isLoaded: true });

  render = () =>
    <div
      className={classNames(
        'gallery-image',
        { active: this.props.isActive }
      )}
      onClick={this.handleClick}
      ref={(element) => { this.divNode = element; }}
    >
      <Lazy>
        { this.responsiveImg() }
      </Lazy>
    </div>;
}

GalleryImage.propTypes = {
  // Passed in by parent component
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,

  // From API
  portrait: PropTypes.shape({
    src: PropTypes.string.isRequired,
    dimensions: PropTypes.shape({
      original_width_px: PropTypes.number.isRequired,
      original_height_px: PropTypes.number.isRequired
    }).isRequired
  }),
  landscape: PropTypes.shape({
    src: PropTypes.string.isRequired,
    dimensions: PropTypes.shape({
      original_width_px: PropTypes.number.isRequired,
      original_height_px: PropTypes.number.isRequired
    }).isRequired
  })
};
